/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateEnvDto
 */
export interface UpdateEnvDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateEnvDto
     */
    operatorMobileDate?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateEnvDto
     */
    operatorMobileNbline?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEnvDto
     */
    operatorMobileCompetitorName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEnvDto
     */
    operatorFixeDate?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateEnvDto
     */
    operatorFixeNbline?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEnvDto
     */
    operatorFixeCompetitorName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEnvDto
     */
    operatorDataDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEnvDto
     */
    operatorDataTechnology?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEnvDto
     */
    operatorDataCompetitorName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEnvDto
     */
    integratorDate?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateEnvDto
     */
    integratorNbchannel?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEnvDto
     */
    integratorCompetitorName?: string | null;
}

/**
 * Check if a given object implements the UpdateEnvDto interface.
 */
export function instanceOfUpdateEnvDto(value: object): value is UpdateEnvDto {
    return true;
}

export function UpdateEnvDtoFromJSON(json: any): UpdateEnvDto {
    return UpdateEnvDtoFromJSONTyped(json, false);
}

export function UpdateEnvDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateEnvDto {
    if (json == null) {
        return json;
    }
    return {
        
        'operatorMobileDate': json['operator_mobile_date'] == null ? undefined : json['operator_mobile_date'],
        'operatorMobileNbline': json['operator_mobile_nbline'] == null ? undefined : json['operator_mobile_nbline'],
        'operatorMobileCompetitorName': json['operator_mobile_competitor_name'] == null ? undefined : json['operator_mobile_competitor_name'],
        'operatorFixeDate': json['operator_fixe_date'] == null ? undefined : json['operator_fixe_date'],
        'operatorFixeNbline': json['operator_fixe_nbline'] == null ? undefined : json['operator_fixe_nbline'],
        'operatorFixeCompetitorName': json['operator_fixe_competitor_name'] == null ? undefined : json['operator_fixe_competitor_name'],
        'operatorDataDate': json['operator_data_date'] == null ? undefined : json['operator_data_date'],
        'operatorDataTechnology': json['operator_data_Technology'] == null ? undefined : json['operator_data_Technology'],
        'operatorDataCompetitorName': json['operator_data_competitor_name'] == null ? undefined : json['operator_data_competitor_name'],
        'integratorDate': json['integrator_date'] == null ? undefined : json['integrator_date'],
        'integratorNbchannel': json['integrator_nbchannel'] == null ? undefined : json['integrator_nbchannel'],
        'integratorCompetitorName': json['integrator_competitor_name'] == null ? undefined : json['integrator_competitor_name'],
    };
}

export function UpdateEnvDtoToJSON(json: any): UpdateEnvDto {
    return UpdateEnvDtoToJSONTyped(json, false);
}

export function UpdateEnvDtoToJSONTyped(value?: UpdateEnvDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'operator_mobile_date': value['operatorMobileDate'],
        'operator_mobile_nbline': value['operatorMobileNbline'],
        'operator_mobile_competitor_name': value['operatorMobileCompetitorName'],
        'operator_fixe_date': value['operatorFixeDate'],
        'operator_fixe_nbline': value['operatorFixeNbline'],
        'operator_fixe_competitor_name': value['operatorFixeCompetitorName'],
        'operator_data_date': value['operatorDataDate'],
        'operator_data_Technology': value['operatorDataTechnology'],
        'operator_data_competitor_name': value['operatorDataCompetitorName'],
        'integrator_date': value['integratorDate'],
        'integrator_nbchannel': value['integratorNbchannel'],
        'integrator_competitor_name': value['integratorCompetitorName'],
    };
}

